<template>

  <v-layout>
    <v-flex xs11>
    <v-card class="itemdimensions" >
      <v-card-title primary-title>
        <v-tooltip bottom>
          <span slot="activator">
            Item dimensions (optional)
            <v-icon :color="$vuetify.theme.primary" class="ml-1" small >{{$vuetify.icons.info}}</v-icon>

          </span>
          <span>Dimensions are used to estimate shipping cost if you choose 'computed shipping' in site settings.<br />Use 0 height if it will fit in an envelope.</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-btn @click="show = !show" flat color="accent">
           Show Dimensions
          <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>


        </v-btn>
      </v-card-title>

      <v-slide-y-transition>
        <v-card-text v-show="show">
          <v-layout>
            <v-flex sm2 xs3 class="mr-1">
              <v-text-field color="accent" type=number @change="change" :rules="dimRules" v-model.number="length" label="Length"></v-text-field>
            </v-flex>
            <v-flex sm2 xs3 class="mr-1">
              <v-text-field color="accent" type=number @change="change" :rules="dimRules" v-model.number="width" label="Width"></v-text-field>
            </v-flex>
            <v-flex sm2 xs3 class="mr-1">
              <v-text-field color="accent" type=number @change="change" :rules="dimRules" v-model.number="height" label="Height" hint="Use 0 height if it will fit in an envelope."></v-text-field>
            </v-flex>
            <v-flex sm1 xs2 >
              <v-select
                color="accent"
                :items="dimensionTypes"
                v-model="dimType"
                hint="Inches or Centimeters"
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex sm2 xs4 class="mr-1">
              <v-text-field color="accent" type=number @change="change" :rules="dimRules" v-model.number="weight" label="Weight"></v-text-field>
            </v-flex>
            <v-flex sm1 xs2 >
              <v-select
                color="accent"
                :items="weightTypes"
                v-model="weightType"
                hint="Pounds or Kilograms"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-slide-y-transition>

      </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
import utils from '../../utils.ts'

export default {
  name: 'ItemDimensions',
  components: {
  },
  props: ['value'],
  data () {
    return {
      show: false,
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      dimType: 'inches',
      weightType: 'lbs',
      dimRules: [
        utils.validNumber('Must be a valid number.')
      ],
      dimensionTypes: [
        {text: '(in)', value: 'inches'},
        {text: '(cm)', value: 'cm'}
      ],
      weightTypes: [
        {text: '(lbs)', value: 'lbs'},
        {text: '(kg)', value: 'kg'}
      ]
    }
  },
  watch: {
    value: function (newVal) {
      this.copy(newVal)
    }
  },
  mounted: function () {
    // Copy it in from props
    this.copy(this.value)
  },

  methods: {
    copy: function (val) {
      // Copy it in from props
      this.length = val.length || null
      this.width = val.width || null
      this.height = val.height || null
      this.weight = val.weight || null
      this.weightType = val.weightType || 'lbs'
      this.dimType = val.dimType || 'inches'
    },
    change: function () {
      const val = {
        length: this.length,
        width: this.width,
        height: this.height,
        weight: this.weight,
        dimType: this.dimType,
        weightType: this.weightType
        // isValid: !this.$v.$anyError
      }
      this.$emit('input', val)
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.itemdimensions {
  border: solid gray 1px;
  text-align: left;
  background-color: var(--v-primary-base);
}
</style>
